'use client'

import { useCachedQuery } from '@/lib/cache'
import { listChannels } from '@/services/channels'
import type { ChannelWithStats } from '@/types/channel'

export const channelsKeys = { all: ['channels'] as const }

/** Lista escopada de canais + contadores, app-wide (seleção, rail, transferência). */
export function useChannelsQuery() {
  return useCachedQuery<ChannelWithStats[]>({
    queryKey: channelsKeys.all,
    queryFn: () => listChannels(),
    refetchInterval: 30_000,
  })
}
